<template>
    <div style="display: contents" ref="root">
        <div class="ProductCategory-aside">
            <FilterHolder :is-loading="isLoadingFilters"></FilterHolder>
            <div style="display: contents" v-if="catalogStore.layoutSections.banner" v-html="catalogStore.layoutSections.banner"></div>
        </div>
        <div class="ProductCategory-content">
            <div style="display: contents" v-if="catalogStore.layoutSections.categoryHeader" v-html="catalogStore.layoutSections.categoryHeader"></div>
            <div style="display: contents" v-if="catalogStore.layoutSections.subCategories" v-html="catalogStore.layoutSections.subCategories"></div>
            <div style="display: contents" v-if="catalogStore.layoutSections.topSeller" v-html="catalogStore.layoutSections.topSeller"></div>
            <div style="display: contents" v-if="catalogStore.layoutSections.recommendedList" v-html="catalogStore.layoutSections.recommendedList"></div>

            <span v-if="isLoadingProducts">{{ loadingProductsLabel }}</span>
            <div style="display: contents;" :class="{'u-hidden': isLoadingProducts}">
                <FilterSelection></FilterSelection>
                <ButtonOpenFilter :text="openFilterLabel" @click="openFilterModal"/>
                <CategorySort></CategorySort>
                <ProductList></ProductList>
                <Pager></Pager>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, PropType, ref, Ref} from "vue";

import CatalogService from "@/services/CatalogService";
import {useStore} from './store';
import {FilterActionTypes} from './store/modules/filter/action-types';
import {ProductActionTypes} from "./store/modules/product/action-types";
import {TranslationActionTypes} from "./store/modules/translation/action-types";
import {Translations} from "@/types";

import FilterHolder from "./components/filter/FilterHolder.vue";
import FilterSelection from "./components/filter/FilterSelection.vue";
import CategorySort from "./components/controls/CategorySort.vue";
import ProductList from "./components/products/ProductList.vue";
import Pager from "./components/controls/Pager.vue";
import ButtonOpenFilter from "@/components/controls/ButtonOpenFilter.vue";
import {mapGetters} from "vuex";
import {useCatalogStore} from "@/store/catalog-store";

declare global {
    interface Window {
        preloadedProductsForVue: any | null
    }
}

export default defineComponent({
    name: "StoreCatalog",
    components: {
        ButtonOpenFilter,
        FilterHolder,
        FilterSelection,
        CategorySort,
        ProductList,
        Pager
    },
    props: {
        translations: {
            type: Object as PropType<Translations>,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            'loadingProductsLabel': 'getLoadingProductsLabel',
            'openFilterLabel': "getOpenFilterLabel",
        })
    },
    setup(props) {
        const root: Ref<HTMLElement | null> = ref(null);
        const isLoadingProducts: Ref<boolean> = ref(true);
        const isLoadingFilters: Ref<boolean> = ref(true);
        const store = useStore();
        const catalogStore = useCatalogStore();

        onMounted(() => {
            store.dispatch(TranslationActionTypes.SET_TRANSLATIONS, props.translations);

            const preloadedProducts = window?.preloadedProductsForVue
            if (preloadedProducts) {
                store.dispatch(ProductActionTypes.SET_PRODUCTS, preloadedProducts).then(() => isLoadingProducts.value = false);
            }

            catalogStore.initializeTmplComponents();
        })

        CatalogService.prepareFilterData()
            .then(result => {
                store.dispatch(FilterActionTypes.SET_FILTER, result).then(() => isLoadingFilters.value = false);
                if (isLoadingProducts.value) {
                    store.dispatch(ProductActionTypes.SET_PRODUCTS, result).then(() => isLoadingProducts.value = false);
                }
            })
            .catch(error => console.error(error));

        function openFilterModal(): void {
            store.dispatch(FilterActionTypes.SET_IS_OPENED_FILTER_MODAL, true);
        }

        return {
            root,
            isLoadingProducts: isLoadingProducts,
            isLoadingFilters: isLoadingFilters,
            openFilterModal,
            catalogStore,
        }
    }
});
</script>
